import cx from "classnames";
import React from "react";

import * as styles from "./FieldHeader.module.css";

export type FieldHeaderProps = Readonly<{
  subtitle?: string;
  subtitleClassName?: string;
}> &
  FieldTitleProps;

export type FieldTitleProps = Readonly<{
  title?: string;
  isRequiredField?: boolean;
  htmlFor?: string;
  titleClassName?: string;
}>;

export type FieldStateProps = Readonly<{
  disabled?: boolean;
  isSaving: boolean;
  ariaLabel?: string;
}>;

export const FieldHeaderTitle = ({
  title,
  isRequiredField,
  htmlFor,
  titleClassName,
}: FieldTitleProps) =>
  title ? (
    <div className={styles.titleGroup}>
      <label
        htmlFor={htmlFor}
        className={cx(styles.title, titleClassName ?? "", styles.titleLabel)}
      >
        {title}
        {isRequiredField && (
          <span className={cx(titleClassName ?? "", styles.requiredStar)}>*</span>
        )}
      </label>
    </div>
  ) : null;

export const FieldHeader = (props: FieldHeaderProps) => {
  const { title, subtitle, subtitleClassName } = props;
  return title || subtitle ? (
    <>
      <FieldHeaderTitle {...props} />
      {subtitle && <p className={cx(subtitleClassName ?? "", styles.subtitle)}>{subtitle}</p>}
    </>
  ) : null;
};
